import React from 'react';

// Pocket Up brand — raster emblem (generated) + gradient wordmark.
export const PocketMark = ({ size = 30, style }) => (
  <img src="/pocketup-logo.png" alt="Pocket Up" width={size} height={size} draggable={false}
    style={{ width: size, height: size, borderRadius: size * 0.28, boxShadow: '0 4px 14px -4px rgba(245,158,11,0.6)', ...style }} />
);

export const PocketBrand = ({ markSize = 30, wordSize = 14 }) => (
  <div className="pk-brand" data-testid="pocket-brand" dir="ltr">
    <PocketMark size={markSize} />
    <span className="pk-brand-word" style={{ fontSize: wordSize }}>POCKET <span className="up">UP</span></span>
  </div>
);
